module.exports = __webpack_public_path__ + "img/logo_banreservas.e79cfe47.png";